if (!customElements.get("td-uvp-drawer")) {
  class TdUvpDrawer extends HTMLElement {
    constructor() {
      super();
      this.body = document.querySelector("body");
      this.overlayClass = "td-uvpd__overlay";
      this.activeClass = "td-uvpd__content-wrapper--active";
    }

    connectedCallback() {
      this.initUvpDrawer();
    }

    initUvpDrawer() {
      const closeButtons = this.querySelectorAll(".td-uvpd__close");

      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener("click", (event) => {
          const contentWrapper = closeButton.closest(".td-uvpd__content-wrapper");
          if (contentWrapper) {
            this.closeDrawer(contentWrapper);
          }
          event.stopPropagation();
        });
      });

      if (this.body) {
        this.body.addEventListener("click", (event) => {
          if (event.target === this.body && this.body.classList.contains(this.overlayClass)) {
            const contentWrapper = this.querySelector(`.${this.activeClass}`);
            if (contentWrapper) {
              this.closeDrawer(contentWrapper);
            }
          }
        });
      }

      this.bindDelegatedTrigger();
    }

    bindDelegatedTrigger() {
      if (document.__tdUvpDrawerTriggerDelegation) return;
      document.__tdUvpDrawerTriggerDelegation = true;

      document.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-trigger-uvp-drawer]");
        if (!trigger) return;

        const drawerInstance = trigger.getAttribute("data-uvp-drawer-instance");
        if (!drawerInstance) return;

        const drawer = document.querySelector(
          `td-uvp-drawer[data-uvp-drawer-instance="${drawerInstance}"]`
        );
        if (!drawer) return;

        const shouldOpenLoox = trigger.getAttribute("data-trigger-loox-reviews") === "true";
        if (shouldOpenLoox) {
          event.preventDefault();
          drawer.closeAllDrawers();
          drawer.openLooxReviews(drawerInstance);
          return;
        }

        const drawerNumber = trigger.getAttribute("data-trigger-uvp-drawer");
        const contentWrapper = drawer.querySelector(
          `[data-uvp-drawer-${drawerNumber}-wrapper]`
        );

        if (contentWrapper) {
          event.preventDefault();
          drawer.openDrawer(contentWrapper);
        }
      });
    }

    openDrawer(contentWrapper) {
      const hasActiveDrawer = Boolean(this.querySelector(`.${this.activeClass}`));

      this.querySelectorAll(`.${this.activeClass}`).forEach((openWrapper) => {
        if (openWrapper !== contentWrapper) {
          openWrapper.classList.remove(this.activeClass);
        }
      });

      if (this.body) {
        this.body.classList.add(this.overlayClass);
        if (!hasActiveDrawer) {
          this.lockBodyScroll();
        }
      }

      contentWrapper.classList.add(this.activeClass);
    }

    closeDrawer(contentWrapper) {
      contentWrapper.classList.remove(this.activeClass);

      if (!this.querySelector(`.${this.activeClass}`) && this.body) {
        this.body.classList.remove(this.overlayClass);
        this.unlockBodyScroll();
      }
    }

    closeAllDrawers() {
      const hadActiveDrawer = Boolean(this.querySelector(`.${this.activeClass}`));

      this.querySelectorAll(`.${this.activeClass}`).forEach((openWrapper) => {
        openWrapper.classList.remove(this.activeClass);
      });

      if (this.body) {
        this.body.classList.remove(this.overlayClass);
        if (hadActiveDrawer) {
          this.unlockBodyScroll();
        }
      }
    }

    openLooxReviews(drawerInstance) {
      const looxProxyTrigger = document.querySelector(
        `[data-loox-uvp-trigger="${drawerInstance}"]`
      );

      if (looxProxyTrigger) {
        this.triggerClick(looxProxyTrigger);
        return;
      }

      if (this.openLooxFromFloatingToggler()) return;

      if (!looxProxyTrigger && window.console && typeof window.console.warn === "function") {
        window.console.warn(
          "TD UVP Drawer: Loox trigger not found for instance",
          drawerInstance
        );
      }
    }

    openLooxFromFloatingToggler() {
      const selectors = [
        ".loox-float-toggler-container button",
        ".loox-float-toggler-container [role='button']",
        ".loox-float-toggler-container .loox-float-toggler",
        ".loox-float-toggler-container",
      ];

      for (const selector of selectors) {
        const toggler = document.querySelector(selector);
        if (!toggler) continue;

        this.triggerClick(toggler);
        return true;
      }

      return false;
    }

    triggerClick(element) {
      if (!element) return;

      if (typeof element.click === "function") {
        element.click();
        return;
      }

      element.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    }

    lockBodyScroll() {
      if (!this.body) return;
      if (!window.TdBodyScrollLock || typeof window.TdBodyScrollLock.lock !== "function") return;
      window.TdBodyScrollLock.lock(this.body);
    }

    unlockBodyScroll() {
      if (!this.body) return;
      if (!window.TdBodyScrollLock || typeof window.TdBodyScrollLock.unlock !== "function") return;
      window.TdBodyScrollLock.unlock(this.body);
    }
  }

  customElements.define("td-uvp-drawer", TdUvpDrawer);
}
